var SingleProduct = angular.module( 'Single-Product', [  ] );
